import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-generic-uniselect',
  templateUrl: './generic-uniselect.component.html',
  styleUrls: ['./generic-uniselect.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericUniselectComponent {
  @Input() name: string = '';
  @Input() uniqueId: string = '';
  @Input() disabled: boolean = false;
  @Input() selectedValue: any[] = [];
  @Input() items: any[] = [];
  @Input() index: any = null;
  @Input() public required: boolean = false;
  @Input() public placeholder: string = '';

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onThemeSelected: EventEmitter<any> = new EventEmitter();

  @ViewChild('chipGrid') chipGrid: ElementRef;
  @ViewChild('inputField') inputField: ElementRef;

  searchControl = new FormControl('');
  filteredItems: any[] = [];

  ngOnInit() {
    this.filteredItems = [...this.items];

    this.placeholder = this.required ? `${this.placeholder}*` : this.placeholder;
    
    // Setup search filtering
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        this.filterItems(searchTerm);
      });
  }

  ngOnChanges() {
    this.filteredItems = [...this.items];
    this.selectedValue = this.selectedValue ? this.selectedValue: [];
  }

  filterItems(searchTerm: string) {
    if (!searchTerm) {
      this.filteredItems = [...this.items];
      return;
    }
    
    this.filteredItems = this.items.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  remove() {
    this.selectedValue = [];
    this.onThemeSelected.emit({value: this.selectedValue, id: this.index});
    this.searchControl.setValue('');
  }

  updateValue(event: any) {
    const selectedItem = event.option.value;
    this.selectedValue = [selectedItem];
    this.onThemeSelected.emit({value: this.selectedValue, id: this.index});
    this.searchControl.setValue('');
    this.filteredItems = [...this.items];
  }
}